export default "__VITE_ASSET__oZvAK1ta__"